import { Attachment } from "@mui/icons-material";
import { styled } from "@mui/material";

export const AttachmentIcon = styled(Attachment)(({ theme }) => ({
  fontSize: '1rem',
  color: theme.palette.primary.main,
  opacity: 0.75,
  cursor: 'pointer',
  transition: 'opacity 0.15s',
  '&:hover': { opacity: 1 },
}));